import { useQuery } from "@tanstack/react-query";

import type {
    IDeviceDistributionResponseData,
    IWebsiteAnalysisTrafficRequestParams,
} from "app/pages/website-analysis/TrafficAndEngagement/types";
import WebsiteAnalysisApiService from "app/services/WebsiteAnalysis/WebsitAnalysisApiService";

interface ICompareDeviceDistributionOptions {
    controller?: string;
    enabled?: boolean;
}

export const useCompareDeviceDistributionData = (
    params: IWebsiteAnalysisTrafficRequestParams,
    { controller, enabled = true }: ICompareDeviceDistributionOptions = {},
) => {
    return useQuery<IDeviceDistributionResponseData>({
        queryKey: ["deviceDistributionCompare", params, controller],
        queryFn: () =>
            WebsiteAnalysisApiService.getInstance().getSingleCompareDeviceDistributionData(params, controller),
        enabled,
    });
};
